// extracted by mini-css-extract-plugin
export default {"zoomModal":"P3-z","image":"Q3-z","button":"R3-z","isOverlayShown":"S3-z"};